import axios from 'axios';
import authHeader from '../services/AuthHeader';

 import {ENV_URL} from './Globals';
const NOTIFICATION_API_URL = `${ENV_URL}/api/v1/notifications`;




class NotificationService {

    //GET All Notification 
    getAllNotification() {
        return axios.get(`${NOTIFICATION_API_URL}`, {
            headers: authHeader()
        });
    };


    //CREATE Notification 
    createNotification(fileData) {
        return axios.post(`${NOTIFICATION_API_URL}`,fileData, {
            "Content-Type": "multipart/form-data",
            headers: authHeader()
        });
    }

    //GET Notificaiton (give Id)
    getNotification(id) {
        return axios.get(`${NOTIFICATION_API_URL}/${id}`, {
            headers: authHeader() 
        });
    };


    //UPDATE  Notification (given ID and body)
    updateNotification(id,data) {
        return axios.put(`${NOTIFICATION_API_URL}/${id}`, data , {
            headers: authHeader()
        });
    };

    //DELETE  Notification 
    deletNotification(id) {
    return axios.delete(`${NOTIFICATION_API_URL}/${id}`, {
        headers: authHeader()
    });
};



//get Notification Picture 
downloadNotificationImage(id) {
    return axios.get(`${NOTIFICATION_API_URL}/${id}/download`, {
        headers: authHeader()
    });  
};

//upload notification Picture
uploadNotificationImage(id) {
    return axios.post(`${NOTIFICATION_API_URL}/${id}/upload`, {
        "file": "file",
        headers : authHeader()
    }
    ); 
};

};

const notificationService = new NotificationService();
export default notificationService;